export default __webpack_public_path__ + "static/media/top.0a4a521e.png";